<header class="modal-header" mat-dialog-title>
  <div class="flex items-baseline">
    <h2 class="!text-2xl modal-headline" i18n>Select export data fields</h2>

    <div class="ml-auto">
      <button mat-icon-button mat-dialog-close class="button-close">
        <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
        <span class="sr-only" i18n>Close</span>
      </button>
    </div>
  </div>
</header>
<mat-dialog-content class="mat-typography">
  <div class="flex gap-4 justify-center">
    <div class="flex-1">
      <div class="flex flex-col">
        <mat-checkbox class="example-margin" [checked]="allComplete" [indeterminate]="someComplete()" (change)="setAll($event.checked)"> Select all </mat-checkbox>
        <div class="column-list" *ngFor="let field of mandatoryFields; let i = index">
          <mat-checkbox *ngIf="!field.hideField" [checked]="field.selected" (change)="selectField($event.checked, i, true)">{{ field.formFieldName }}</mat-checkbox>
        </div>
      </div>
    </div>
    <mat-divider vertical="true"></mat-divider>
    <div class="column-list-box flex-1">
      <div class="column-list" *ngFor="let field of nonMandatoryFields; let i = index">
        <ng-template [ngIf]="!field.formFieldGroup || field.formFieldGroup.length === 0">
          <mat-checkbox [checked]="field.selected" (change)="selectField($event.checked, i)">{{ field.formFieldName }}</mat-checkbox>
        </ng-template>
        <ng-template [ngIf]="field.formFieldGroup && field.formFieldGroup.length > 0">
          <mat-checkbox [checked]="field.selected" (change)="setAllSubFields($event.checked, field.formFieldGroup, i)" [indeterminate]="someSubFieldsComplete(field.formFieldGroup)">{{
            field.formFieldName
          }}</mat-checkbox>
          <div class="column-list ml-10" *ngFor="let subField of field.formFieldGroup; let i = index">
            <mat-checkbox [checked]="subField.selected" (change)="selectSubField($event.checked, i, field.formFieldGroup)">{{ subField.formFieldName }}</mat-checkbox>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center" class="dailog-action w-full gap-4 !justify-between">
  <button type="button" class="button-primary" mat-flat-button (click)="resetView()">
    <mat-icon class="material-icons-outlined ml-2">restart_alt</mat-icon>
    <span i18n>Reset</span>
  </button>
  <button type="button" class="save-button button-primary" (click)="exportData()" mat-flat-button>
    <mat-icon class="material-icons-outlined ml-2">drive_file_move</mat-icon>
    <span i18n>Export</span>
  </button>
</mat-dialog-actions>
